import React from 'react'
import Bredcom from '../Bredcom/Main'
import First from '../Menblog/First'

function Main() {
  return (
    <>
        <Bredcom title="Blog" subtitle="Home" subtitledown="Blog" />
        <First/>
    </>
  )
}

export default Main